import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pantry-detail-data-value" }
const _hoisted_2 = {
  key: 0,
  class: "pantry-detail-data-value-date-value-text"
}
const _hoisted_3 = {
  key: 1,
  class: "pantry-detail-data-value-stock-area"
}
const _hoisted_4 = { class: "pantry-detail-data-value-stock-value-text" }
const _hoisted_5 = { class: "pantry-detail-data-value-stock-text" }
const _hoisted_6 = {
  key: 2,
  class: "pantry-detail-data-value-storage-value-text"
}
const _hoisted_7 = {
  key: 3,
  class: "pantry-detail-data-value-notification-area"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-data-value-notification-text" }, "期限", -1)
const _hoisted_9 = { class: "pantry-detail-data-value-notification-value-text" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-data-value-notification-text" }, "日前", -1)
const _hoisted_11 = {
  key: 4,
  class: "pantry-detail-data-value-date-value-text"
}
const _hoisted_12 = {
  key: 5,
  class: "pantry-detail-data-value-notification-area"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-data-value-notification-text" }, "残り", -1)
const _hoisted_14 = { class: "pantry-detail-data-value-notification-value-text" }
const _hoisted_15 = { class: "pantry-detail-data-value-notification-text" }
const _hoisted_16 = {
  key: 6,
  class: "pantry-detail-data-value-date-value-text"
}
const _hoisted_17 = {
  key: 7,
  class: "pantry-detail-data-value-date-value-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isShowDate())
      ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.getDateValue()), 1))
      : (_ctx.isShowStock())
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getStockValue()), 1),
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getStockUnit()), 1)
          ]))
        : (_ctx.isShowStorage())
          ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.value), 1))
          : (_ctx.isShowNotificationValue())
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.getNotificationDate()), 1),
                _hoisted_10
              ]))
            : (_ctx.isShowNotificationNone())
              ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.PANTRY_STRING.PANTRY_NONE_NOTIFICATION), 1))
              : (_ctx.isShowStockNotificationValue())
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.getStockNotificationValue()), 1),
                    _createVNode("div", _hoisted_15, _toDisplayString(_ctx.getStockNotificationUnit()), 1)
                  ]))
                : (_ctx.isShowStockNotificationTime())
                  ? (_openBlock(), _createBlock("div", _hoisted_16, _toDisplayString(_ctx.getStockNotificationTime()), 1))
                  : (_ctx.isShowStockNotificationNone())
                    ? (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(_ctx.getStockNotificationText()), 1))
                    : _createCommentVNode("", true)
  ]))
}